
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.372 3.395V13.62l-1.634-1.64-.084-.073a.75.75 0 00-.98 1.132l2.917 2.928.002.002a.756.756 0 00.079.068l.003.003a.75.75 0 00.979-.073l2.916-2.928.072-.085a.75.75 0 00-.074-.976l-.085-.072a.75.75 0 00-.976.074l-1.635 1.64V3.396l-.007-.102a.75.75 0 00-1.493.102zm6.533 17.722a4.425 4.425 0 004.217-4.42v-4.884l-.005-.209a4.434 4.434 0 00-4.429-4.226h-.933l-.102.007a.75.75 0 00.102 1.493h.933l.172.005a2.934 2.934 0 012.762 2.93v4.884l-.005.172a2.925 2.925 0 01-2.92 2.753H6.557l-.172-.005a2.935 2.935 0 01-2.763-2.93v-4.885l.005-.172a2.925 2.925 0 012.92-2.752h.942l.102-.007a.75.75 0 00-.102-1.493h-.942l-.214.005a4.425 4.425 0 00-4.21 4.419v4.885l.004.209a4.435 4.435 0 004.43 4.226h11.14l.208-.005z","fill":"#FCFDFF"}})])
          )
        }
      }
    